import React, { useState, useEffect } from "react";
import { Switch, FormControlLabel } from "@mui/material";
import { Box, Card, Typography, TextField, Button } from "@mui/material";
import useExecutionSetup, { useGetExeUrls } from "../../useQuery/useAddselhubComp"
import { useToggleSelenoid, useSaveSelenoidUrl, useGetSelenoidFlag, useGetSelenoidUrl } from "../../useQuery";
import { useNotification } from "../../hooks";
export default function ExecutionSetup() {
  const [hubUrl, setHubUrl] = useState("");
  const [selenoidUrl, setSelenoidUrl] = useState("");
  const [enableSelenoid, setEnableSelenoid] = useState(false);
  const notify = useNotification();
  const { data: exeUrlsData } = useGetExeUrls();
  const { data: selenoidFlag } = useGetSelenoidFlag();
  const { data: selenoidUrlData } = useGetSelenoidUrl();
  useEffect(() => {
  if (exeUrlsData?.value) {
    setHubUrl(exeUrlsData.value);
  }
}, [exeUrlsData]);

useEffect(() => {
  if (selenoidFlag?.value !== undefined) {
    setEnableSelenoid(selenoidFlag.value);
  }
}, [selenoidFlag]);

useEffect(() => {
  if (selenoidUrlData?.value) {
    setSelenoidUrl(selenoidUrlData.value);
  }
}, [selenoidUrlData]);
  const { mutate: saveExecution } = useExecutionSetup({
    onSuccess: () => {
      console.log("Saved successfully");
    },
    onError: () => {
      console.log("Failed");
    },
  });
    const { mutate: toggleSelenoid, isLoading: toggleLoading } = useToggleSelenoid({
    onSuccess: () => notify("Selenoid toggled successfully", "success"),
    onError: () => notify("Failed to toggle Selenoid", "error"),
});

const { mutate: saveSelenoidUrl, isLoading } = useSaveSelenoidUrl({
  onSuccess: () => notify("Selenoid URL saved successfully", "success"),
  onError: () => notify("Failed to save Selenoid URL", "error"),

});
  const handleSubmit = () => {
    console.log("D");
    if (!hubUrl.trim()) return;
    // onSubmit(hubUrl);
    saveExecution({
      hubUrl: hubUrl,
    });
  };

  const handleSelenoidSubmit = async () => {   
  if (!selenoidUrl.trim()) return;
 saveSelenoidUrl(selenoidUrl);
};

  return (
    <Box>
      {/* Header */}
      <Box sx={{ mb: 2 }}>
        <Typography variant="h6" sx={{ fontWeight: 600 }}>
          Execution Setup
        </Typography>
      </Box>

      {/* Card */}
      <Card sx={{ p: 3, maxWidth: "500px" }}>
        <Box sx={{ mb: 2 }}>
          <Typography variant="body2" sx={{ mb: 1, fontWeight: 500 }}>
            Selenium Hub URL
          </Typography>

          <TextField
            value={hubUrl}
            onChange={(e) => setHubUrl(e.target.value)}
            placeholder="http://localhost:4444"
            fullWidth
            size="small"
          />
        </Box>

        <Button variant="contained" onClick={handleSubmit} disabled={!hubUrl.trim()}>
          Submit
        </Button>

      <Box sx={{ mt: 3, pt: 3, borderTop: "1px solid", borderColor: "divider" }}>
          <Box sx={{ mb: 2 }}>
  <Box
    sx={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
    }}
  >
    <Typography variant="body2" sx={{ fontWeight: 500 }}>
      Selenoid URL
    </Typography>

    <FormControlLabel
      control={
        <Switch
          checked={enableSelenoid}
          onChange={(e) => {
            const checked = e.target.checked;
            setEnableSelenoid(checked);
            toggleSelenoid(checked);
          }}
          disabled={toggleLoading}
          />
      }
      label="Enable Selenoid URL"
    />
  </Box>
            <TextField
              value={selenoidUrl}
              onChange={(e) => setSelenoidUrl(e.target.value)}
              placeholder="http://localhost:5555"
              fullWidth
              size="small"
            />
          </Box>
          <Button
            variant="contained"
            onClick={handleSelenoidSubmit}
            disabled={isLoading || !selenoidUrl.trim()}
          >
            {isLoading ? "Saving..." : "Submit"}
          </Button>
        </Box>
      </Card>
    </Box>
  );
}
